import {useEffect, useState} from 'react';

/**
 * 页面可见性检测Hook
 * 基于Page Visibility API检测页面是否可见，用于优化后台页面的资源消耗
 */
export const usePageVisibility = () => {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const resolveVisibility = () => {
            if ('hidden' === document.visibilityState) {
                return false;
            }
            return document.hasFocus();
        };

        const syncVisibility = () => {
            setIsVisible(resolveVisibility());
        };

        setIsVisible(resolveVisibility());

        document.addEventListener('visibilitychange', syncVisibility);
        window.addEventListener('focus', syncVisibility);

        return () => {
            document.removeEventListener('visibilitychange', syncVisibility);
            window.removeEventListener('focus', syncVisibility);
        };
    }, []);

    return isVisible;
};

export default usePageVisibility;
